

export function isset(obj) {
	if (obj == undefined || obj == null) {
		return false;
	}
	return true;
}

export function isDict(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]';
}

export function get(obj, def) {
	if (isset(obj)) { 
		return obj;
	} else {
		return def;
	}
}

export function output_secure(string) {
	if (!string) return '';
	return string.replace('/<\/?script>?/gmi', '');
}

export function addClass(element, className) {

	var classes = element.className.split(" ");
	var i = classes.indexOf(className);
	if (i < 0) {

		classes.push(className);
	}
	element.className = classes.join(" ");

}

export function rmClass(element, className) {


	var classes = element.className.split(" ");
	var i = classes.indexOf(className);
	if (i >= 0) {
		classes.splice(i, 1);
	}
	element.className = classes.join(" ");

}


export function sleep(min, max=null) {
	if(max === null) max = min;
	let random = Math.floor(Math.random() * (max - min)) + min;
	return new Promise(resolve => setTimeout(resolve, random));
}

var LIMIT_COUNT = 0
var LIMIT_TIME = 0
var LIMIT_THRESOLD = 20
export async function limit(){
	if(Date.now() - LIMIT_TIME > 1000){
		LIMIT_COUNT = 0
	}
	if(LIMIT_COUNT >= LIMIT_THRESOLD){
		await sleep(1000)
		LIMIT_COUNT = 0
	}
	LIMIT_TIME = Date.now()
	LIMIT_COUNT += 1
}

export function clearNumber(string) {
	if (!string) return 0;
	return string.toString().replace(/[^\d\-\.]/g, '');
}

export function isNumber(value){
	if(typeof(value) == 'number') return true;
	if(typeof(value) == 'string'){
		return /^[-+]?[\d,]+(\.\d+)?$/.test(value);
	}
	return false;
}

export function formatNumber(num, round = null, fixed = false) {
	if (!num) return 0;
	num = num.toString().replace(/[^\d\-\.]/g, '');

	if (round !== null) {
		if (fixed) {
			num = Number(num).toFixed(round)
		} else {
			num = Math.round(Number(num) * 10 ** round) / (10 ** round)
		}
	}
	num = num.toString()
	if (num.includes('.')) {
		return num.replace(/(\d)(?=(\d{3})+(?=\.))/g, '$1,')
	} else {
		return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	}
}

export function makeId(length = 16) {
	return Array.from({ length }, () => Math.floor(Math.random() * 36).toString(36)).join('') + Date.now().toString(36);
}

export function firstUpCase(string) {
	if (typeof (string) != 'string') return string
	return string.charAt(0).toLocaleUpperCase() + string.slice(1);
}

export function isMobile() {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function changeArrayPosition(array, from, to) {
	let element = array.splice(from, 1)[0]
	array.splice(to, 0, element);
	return array
}

export function deviceId() {
	let deviceId = localStorage.getItem('DEVICE_ID');
	if (!deviceId) {
		deviceId = makeId(); // Tạo UUID ngẫu nhiên
		localStorage.setItem('DEVICE_ID', deviceId);
	}
	return deviceId;
}

